import React, { useMemo } from 'react';
import { useIntl, history } from 'umi';
import SvgIcon from '@/pages/home/components/SvgIcon';
import { LANGUAGE_EN } from '@/pages/home/_config/config';
import KeyMetricsCard from '@/pages/home/pages/studio/components/KeyMetricsCard';
import { IMetricCardProps, IMetricCardTitleProps } from '@/pages/home/pages/studio/type';
import './index.scss';
import { notification } from 'tea-component';
import { getImageByKey } from '../../inGameAnalytics/utils';
import { JumpType, navigate } from '@home/utils/utils';

// 公共跳转函数
const clickJump = ({
  url,
  gameCode,
  // Studio 专区的卡片和标题默认跳转为新开标签页
  jumpType = JumpType.Window,
  formatMessage,
}: {
  url: string;
  gameCode: string;
  jumpType?: JumpType;
  formatMessage: any;
}) => {
  if (!gameCode) return;

  if (url === 'notification') {
    return notification.error({
      description: formatMessage({ id: 'dbh_table_not_complete' }),
      duration: 2000,
    });
  }

  // /studio/、/dashboard/ 或外链视为绝对路径；其余（含 /overview/...）仍拼经分前缀
  const isExternalUrl = /^(https?:\/\/|\/\/)/.test(url);
  const isAbsolutePath =
    url.startsWith('/studio/') ||
    url.startsWith('/dashboard/') ||
    isExternalUrl;
  const resolvedUrl = isAbsolutePath
    ? url
    : `/dashboard/game/${gameCode}/${url.replace(/^\//, '')}`;

  if (jumpType === JumpType.Window || !isExternalUrl) {
    navigate(resolvedUrl, { jumpType });
    return;
  }

  window.location.href = resolvedUrl;
};

const MetricCard = (props: IMetricCardProps) => {
  const { metric, keyMetricsData, gameCode = '' } = props;
  const { locale, formatMessage } = useIntl();
  const { cardType, icon, title, desc, jumpUrl = '' } = useMemo(() => {
    const { cardType = 'row', icon, titleEn, titleCn, descEn, descCn, jumpUrl } = metric || {};
    const isEn = locale === LANGUAGE_EN;
    const title = isEn && titleEn ? titleEn : titleCn;
    const desc = isEn && descEn ? descEn : descCn;
    const url = jumpUrl === "undefined" ? undefined : jumpUrl;
    return { cardType, icon: getImageByKey(icon), title, desc, jumpUrl: url};
  }, [metric, locale]);

  const handleOnClick = () => {
    clickJump({url: jumpUrl, gameCode, jumpType: JumpType.Window, formatMessage});
  };

  const renderMap: any = {
    row: <div className='dbh-engagement-card' onClick={handleOnClick}>
      <div className='dbh-engagement-card-img'>
        <SvgIcon type={icon} className='dbh-engagement-card-icon' />
      </div>
      <div className="dbh-engagement-card-context">
        <div className="dbh-engagement-card-title">{title}</div>
        <div className="dbh-engagement-card-desc">{desc}</div>
      </div>
    </div>,
    col: <div className='dbh-sales-card' onClick={handleOnClick}>
      <div className='dbh-sales-card-img'  >
        {/* style={{ backgroundImage: `url(${icon})` }} */}
        <img className='dbh-img-cover' src={icon} />
      </div>
      <div className="dbh-sales-card-context">
        <div className="dbh-sales-card-title">{title}</div>
        <div className="dbh-sales-card-desc">{desc}</div>
      </div>
    </div>,
    metric: <KeyMetricsCard metric={metric} keyMetricsData={keyMetricsData} onClick={handleOnClick} gameCode={gameCode} />
  };

  return <>
    <MetricCardTitle metric={metric} gameCode={gameCode} />
    {renderMap?.[cardType]}
  </>;
};

export const MetricCardTitle = (props: IMetricCardTitleProps) => {
  const { metric, gameCode = '', jumpType = JumpType.Window } = props;
  const { locale, formatMessage } = useIntl();
  const { headerTitle, headerJumpUrl } = useMemo(() => {
    const { headerJumpUrl = '', headerTitleEn, headerTitleCn } = metric || {};
    const isEn = locale === LANGUAGE_EN;
    const headerTitle = isEn && headerTitleEn ? headerTitleEn : headerTitleCn;
    return { headerTitle, headerJumpUrl };
  }, [metric, locale]);

  const handleOnClick = () => {
    clickJump({url: headerJumpUrl, gameCode, jumpType, formatMessage});
  };

  return <div className={`dbh-component-title ${headerJumpUrl ? 'dbh-component-title-hover' : ''}`} onClick={handleOnClick}>
    <span className='dbh-component-title-text'>{headerTitle}</span>
    {headerJumpUrl && <SvgIcon type='point-right' className='dbh-component-title-icon' />}
  </div>;
};

export default MetricCard;